import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Button from 'src/components/buttons/button';
import { closeModal } from 'src/modules/shared/modal/actions';

class CustomModal extends React.Component {
  static propTypes = {
    accept: PropTypes.string,
    cancel: PropTypes.string,
    children: PropTypes.any,
    contentClasses: PropTypes.object,
    dialogClasses: PropTypes.object,
    modalClasses: PropTypes.object,
    noClose: PropTypes.bool,
    size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'login', 'signup', 'custom']),
    textCentered: PropTypes.bool,
    title: PropTypes.any,
    verticallyCentered: PropTypes.bool,
    onAccept: PropTypes.func,
    onClose: PropTypes.func,
    onCancel: PropTypes.func,
  }

  static defaultProps = {
    noClose: false,
    size: 'medium',
    verticallyCentered: true,
    textCentered: false,
    children: null,
    contentClasses: {},
    dialogClasses: {},
    modalClasses: {},
    onCancel: () => {},
  }

  constructor(props) {
    super(props);
    // [BB-1656] there's a bug on safari ios11 that makes the cursor to be outside textboxes
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.isIOS11 = isIOS && /OS 11_0|OS 11_1|OS 11_2/.test(navigator.userAgent);
  }

  componentDidMount() {
    if (this.isIOS11) {
      window.document.body.classList.add('ios11');
    }
  }

  componentWillUnmount() {
    if (this.isIOS11) {
      window.document.body.classList.remove('ios11');
    }
  }

  onFinished = () => {
    this.props.closeModal();
  }

  onClose = () => {
    if (this.props.onClose) this.props.onClose();
    this.onFinished();
  }

  onCancel = () => {
    this.onClose();
    this.props.onCancel();
  }

  toggle =() => {
    if (!this.props.noClose) {
      this.onClose();
    }
  }

  renderFooterButtons = () => {
    const acceptButtonClasses = classNames({
      'app-modal__split-button': this.props.cancel,
      'app-modal__full-width': !this.props.cancel,
      'app-modal__button': true,
    });

    const closeButtonClasses = classNames({
      'app-modal__split-button': true,
      'app-modal__button': true,
    });

    return (
      <ModalFooter className="modal-button-container">
        {this.props.onAccept && <Button
          className={acceptButtonClasses}
          isSubmit={true}
          text={this.props.accept}
          onClick={() => {
            this.props.onAccept();
            this.onClose();
          }}
        />}
        {this.props.cancel &&
          <Button
            className={closeButtonClasses}
            text={this.props.cancel}
            type="tertiary"
            onClick={this.onCancel}
          />}
      </ModalFooter>
    );
  }

  renderDefault() {
    return (
      <div>
        <ModalHeader className="modal-header">
          {this.props.title}
        </ModalHeader>
        <ModalBody>
          {this.props.children}
        </ModalBody>
        {(this.props.onAccept || this.props.cancel) && this.renderFooterButtons()}
      </div>
    );
  }

  render() {
    const { noClose, size, textCentered, verticallyCentered } = this.props;

    const modalClasses = classNames({
      'app-modal': true,
      ...this.props.modalClasses,
    });

    const dialogClasses = classNames({
      'modal-dialog-centered': verticallyCentered,
      [`modal-${this.props.size}`]: !!size,
      ...this.props.dialogClasses,
    });

    const contentClasses = classNames({
      'modal-content': true,
      'modal-content--centered': textCentered,
      ...this.props.contentClasses,
    });

    return (
      <Modal
        backdropClassName="app-modal__backdrop"
        className={dialogClasses}
        contentClassName={contentClasses}
        isOpen={true}
        modalClassName={modalClasses}
        toggle={this.toggle}
      >
        {!noClose &&
        <button
          className="modal-close icon-close"
          type="button"
          onClick={this.onClose}
        />}
        {this.props.title ? this.renderDefault() : this.props.children}
      </Modal>
    );
  }
}

export default connect(null, { closeModal })(CustomModal);



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/modal.js